import { authHeader } from '../helpers';

export const userService = {
    login,
    logout,
    add,
    setWorkerChip,
    getAll,
};

var VUE_APP_BACKEND = "https://lifesourcebackend.azurewebsites.net";

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(
            { 
                UserName: username, 
                Password: password 
            })
    };

    return fetch(VUE_APP_BACKEND + '/api/auth/portal/login', requestOptions)
        .then(handleResponse)
        .then(response => {
            // login successful if there's a jwt token in the response
            if (response.tokenJwt) {
                response.worker.loginDate = new Date();
                response.worker.token = response.tokenJwt;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(response.worker));
            }

            return response.worker;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function add(worker){
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(worker)
    };

    return fetch(VUE_APP_BACKEND + '/api/worker', requestOptions)
        .then(handleResponse);
}

function setWorkerChip(request){
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(request)
    };

    return fetch(VUE_APP_BACKEND + '/api/worker/chip', requestOptions)
        .then(handleResponse);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(VUE_APP_BACKEND + '/api/worker', requestOptions).then(handleResponse);
}


function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}